<template>
  <div class="copay-epa-source-filter-list">
    <b-table
      striped
      hover
      :fields="gridFields"
      :busy.sync="busy"
      :items="filters"
      :tbody-tr-class="rowClass"
      primary-key="setting_key_id"
    >
      <div slot="table-busy" class="text-center my-2">
        <i class="fa fa-spinner fa-pulse"></i>
        <strong>Working...</strong>
      </div>
      <template slot="filter_friendly_name" slot-scope="data">
        <a v-if="isAdmin && getEffectiveStatus(data.item) !== 'deleted'"
          href
          @click.prevent="$emit('edit', data.item)"
        >{{data.value || data.item.setting_key_id}}</a>
        <span v-if="isApprover || getEffectiveStatus(data.item) === 'deleted'">{{data.value || data.item.setting_key_id}}</span>
        <div v-if="isApprover && getEffectiveStatus(data.item) !== 'new'">
          <a href @click.prevent="$emit('view-active', data.item)">View Published</a>
        </div>
      </template>
      <template slot="filter_ndc_numbers" slot-scope="data">
        <div v-if="data.item.filter_ndc_numbers.length==0 && data.item.filter_any_ndc_numbers">All</div>
        <div v-else>
          <div v-for="item in data.value" :key="item">{{item}}</div>
        </div>
      </template>
      <template slot="filter_rejection_codes" slot-scope="data">
        <div v-if="data.item.filter_any_rejection_codes">All</div>
        <div v-else>
          <div v-for="item in data.value" :key="item">{{item}}</div>
        </div>
      </template>
      <template slot="filter_rules" slot-scope="data">
        <span v-if="data.value && data.value.length>0 && data.item.status !== 'deleted'">
          <a href @click.prevent="$emit('edit', data.item)">View additional rules</a>
        </span>
      </template>
      <template slot="occ_drug_names" slot-scope="data">
        <div v-for="item in data.value" :key="item">{{item}}</div>
      </template>
      <template
        slot="current_status"
        slot-scope="data"
      >{{ getEffectiveStatus(data.item) | snakeToTitleCase}}</template>
      <template
        slot="status"
        slot-scope="data"
      >{{ data.value | snakeToTitleCase}}</template>
      <template slot="actions" slot-scope="data">
        <div v-if="(isApprover || isAdmin) && data.item.status === 'pending_approval'">
          <a href @click.prevent="$emit('edit', data.item)">View for Approval</a>
        </div>
        <div v-if="isAdmin && getEffectiveStatus(data.item) !== 'new' && data.item.status === 'edit'">
          <a href @click.prevent="$emit('view-active', data.item)">View Published</a>
        </div>
        <div v-if="isAdmin && (data.item.status === 'edit' || data.item.status === 'new' || data.item.status === 'denied')">
          <a href @click.prevent="$emit('request-approval', data.item)">Request Approval</a>
        </div>
        <div v-if="isAdmin && getEffectiveStatus(data.item) === 'new' && (data.item.status === 'new' || data.item.status === 'edit' || data.item.status === 'pending_approval')">
          <a href @click.prevent="$emit('cancel-update', data.item)">Delete</a>
        </div>
        <div v-if="isAdmin && getEffectiveStatus(data.item) !== 'new' && data.item.status === 'pending_approval'">
          <a href @click.prevent="$emit('cancel-update', data.item)">Cancel Approval Request</a>
        </div>
        <div v-if="isAdmin && getEffectiveStatus(data.item) !== 'new' && data.item.status === 'edit'">
          <a href @click.prevent="$emit('cancel-update', data.item)">Cancel Edit</a>
        </div>
        <div v-if="isApprover && data.item.status === 'pending_approval'">
          <a href @click.prevent="$emit('approve', data.item)">Approve</a>
        </div>
        <div v-if="isApprover && data.item.status === 'pending_approval'">
          <a href @click.prevent="$emit('deny', data.item)">Deny</a>
        </div>
        <div v-if="isApprover && data.item.status === 'approved'">
          <a href @click.prevent="$emit('publish', data.item)">Publish</a>
        </div>
      </template>
    </b-table>
  </div>
</template>
<script>
export default {
  name: "VCopayEPAFilterList",
  props: {
    filters: {
      required: true,
      type: Array
    },
    busy: {
      required: false,
      type: Boolean
    },
    isAdmin: {
      required: false,
      type: Boolean
    },
    isApprover: {
      required: false,
      type: Boolean
    },
    showRejectionCodes: {
      required: false,
      type: Boolean
    },
    showFilterRules: {
      required: false,
      type: Boolean
    },
    showOCCDrugNames: {
      required: false,
      type: Boolean
    }
  },
  computed: {
    gridFields: {
      get() {
        let fields = [];
        fields.push({key: "filter_friendly_name", class: "id-field", label: "Name", sortable: false});
        fields.push({key: "filter_ndc_numbers", class: "ndc-field", label: "NDCs", sortable: false});
        if (this.showRejectionCodes) {
          fields.push({key: "filter_rejection_codes", class: "rejection-code-field", label: "Reject Codes", sortable: false});
        }
        if (this.showFilterRules) {
          fields.push({key: "filter_rules", label: "Rules", sortable: false});
        }
        if (this.showOCCDrugNames) {
          fields.push({key: "occ_drug_names", label: "OCC Drug Names", sortable: false});
        }
        fields.push({key: "current_status", label: "Filter Status", sortable: true});
        fields.push({key: "status", label: "Workflow Status", sortable: true});
        fields.push({key: "actions", class: "action-field", label: "", sortable: false});
        return fields;
      }
    }
  },
  methods: {
    rowClass(item, type) {
      const now = new Date().toISOString();
      if (!item) return;
      if (
        item.is_pending_inactivation ||
        item.current_status === "inactive" ||
        item.current_status === "deleted" ||
        (item.current_filter_start_date &&
          item.current_filter_end_date &&
          (now < item.current_filter_start_date || item.current_filter_end_date < now))
      ) {
        return "table-warning";
      }
    },
    getEffectiveStatus(item) {
      const now = new Date().toISOString();
      if (
        item.current_filter_start_date &&
        now < item.current_filter_start_date
      ) {
        return `inactive until ${new Date(
          item.current_filter_start_date
        ).toLocaleDateString()}`;
      } else if (
        item.current_filter_end_date &&
        item.current_filter_end_date < now
      ) {
        return "inactive";
      } else if (
        item.current_status === "active" &&
        item.current_filter_end_date &&
        item.current_filter_end_date > now &&
        item.current_filter_end_date.indexOf('2099-01-01') === -1
      ) {
        return `active until ${new Date(
          item.current_filter_end_date
        ).toLocaleDateString()}`;
      }
      return item.current_status;
    }
  }
};
</script>
<style lang="scss">
.copay-epa-source-filter-list {
  .id-field {
    width: 300px;
  }
  .rejection-code-field {
    width: 200px;
  }
  .ndc-field {
    width: 200px;
  }
  .action-field {
    width: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/VCopayEPAFilterList.vue